import Reflux from "reflux";
import logger from "../../../../utils/LoggerFrontend";
import Actions from "./TemplatePostActions";
import { t } from "i18next";

import {
  IMAGE_TEMPLATES_INFO,
  VIDEO_TEMPLATES_INFO
} from "@talentbait/remotion-templates-talentbait";

const TEMPLATES = {
  ...IMAGE_TEMPLATES_INFO,
  ...VIDEO_TEMPLATES_INFO
};

const OLD_TEMPLATES_MAP = {
  ImageLogoText: IMAGE_TEMPLATES_INFO.PortraitImage.id,
  ImageLogo: IMAGE_TEMPLATES_INFO.PortraitImage.id,
  LandscapeLogo: IMAGE_TEMPLATES_INFO.LandscapeImage.id,
  LandscapeLogoText: IMAGE_TEMPLATES_INFO.LandscapeImage.id
};

const defaultState = () => ({
  templateId: IMAGE_TEMPLATES_INFO.DefaultImage.id,
  template: IMAGE_TEMPLATES_INFO.DefaultImage,
  inputProps: {
    primaryTextColor: "#FFFFFF",
    primaryBackgroundColor: "#005ea8",
    backgroundImage:
      "https://res.cloudinary.com/dyiuxe5fa/image/upload/c_crop,ar_1/v1663692189/tb-campaign-photos/kunze%2Bstamm/bruder_spielwaren_gmbh_%2B_co__kg/shutterstock_1958672599_bl5yjv_oxx75q.jpg",
    logo: "",
    text: t("We are looking for you"),
    secondaryText: t("Are you ready?"),
    CTAText: t("Apply now"),
    orientation: "portrait"
  },
  currentInputProps: {},
  showPictureEditor: false,
  selectedCreativeKey: "backgroundImage",
  isFetchingMediaAsset: true,
  isGeneratingMediaAsset: false,
  templateType: "image"
});

export default class TemplatePostStore extends Reflux.Store {
  constructor(props) {
    super(props);

    this.state = Object.assign({}, defaultState());

    this.listenables = Actions;
  }

  onUpdateInputProps(updates = {}) {
    logger.debug("TemplatePostStore:onUpdateInputProps", "updating input props", { updates });

    this.setState({
      inputProps: { ...this.state.inputProps, ...updates }
    });
  }

  onUpdateCurrentInputProps = (updates = {}) => {
    logger.debug("TemplatePostStore:onUpdateCurrentInputProps", "updating current input props", {
      updates
    });

    this.setState({
      currentInputProps: { ...this.state.inputProps, ...updates }
    });
  };

  onUpdateShowPictureEditor(showPictureEditor) {
    this.setState({ showPictureEditor });
  }
  onUpdateSelectedCreativeKey(selectedCreativeKey) {
    this.setState({ selectedCreativeKey });
  }

  onUpdateTemplateType({ templateType, isTikTokVideo = false }) {
    let defaultTemplateId =
      templateType === "video" ? TEMPLATES.RawVideo.id : TEMPLATES.PortraitImage.id;

    if (isTikTokVideo) {
      defaultTemplateId = TEMPLATES.TikTokVideo.id;
    }

    this.setState({
      templateType: templateType,
      templateId: defaultTemplateId,
      template: TEMPLATES[defaultTemplateId]
    });
  }

  onUpdateTemplateId(templateId, templateTypeSelected) {
    const cleanInputProps = { ...this.state.inputProps };
    const cleanTemplateId = OLD_TEMPLATES_MAP[templateId] || templateId;

    if (templateId === "ImageLogo" || templateId === "LandscapeLogo") {
      cleanInputProps.text = "";
    }

    this.setState({
      inputProps: { ...this.state.inputProps, ...cleanInputProps },
      templateId: cleanTemplateId,
      template: TEMPLATES[cleanTemplateId],
      templateType: templateTypeSelected
    });
  }

  onGetMediaAssetWithId() {
    this.setState({ isFetchingMediaAsset: true });
  }

  // When fetching a media asset, update input props and the selected template settings
  onGetMediaAssetWithIdCompleted(mediaAsset) {
    const { inputProps, templateId, type } = mediaAsset;

    // Backwards compatibility for old templates
    const cleanInputProps = { ...inputProps };
    const cleanTemplateId = OLD_TEMPLATES_MAP[templateId] || templateId;

    if (templateId === "ImageLogo" || templateId === "LandscapeLogo") {
      cleanInputProps.text = "";
    }

    const template = TEMPLATES[cleanTemplateId];

    if (template.orientation === "multi" && cleanInputProps.orientation === "") {
      cleanInputProps.orientation = "portrait";
    } else if (template.orientation !== "multi") {
      cleanInputProps.orientation = template.orientation;
    }

    this.setState({
      inputProps: { ...this.state.inputProps, ...cleanInputProps },
      templateId: cleanTemplateId,
      template,
      templateType: type,
      isFetchingMediaAsset: false
    });
  }
  onGetMediaAssetWithIdFailed() {
    this.setState({ isFetchingMediaAsset: false });
  }
  onGenerateDefaultMediaAsset() {
    this.setState({ isGeneratingMediaAsset: true });
  }
  onGenerateDefaultMediaAssetCompleted() {
    this.setState({ isGeneratingMediaAsset: false });
  }
  onGenerateDefaultMediaAssetFailed() {
    this.setState({ isGeneratingMediaAsset: false });
  }
}
